import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import ModalChangeConfirmation from "screens/ModalConfirmationRequired";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { UPDATE_PHONE_NUMBER_BY_USER_ID } from "graphql/service";
import { Head, Container, Footer } from "./styles";

const ModalChangePhoneNumber = ({
  hidden,
  buttonStyle,
  userId
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [confirmationIsOpen, setConfirmationIsOpen] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState(false);

  const [updatePhoneNumberByUserId, { loading }] = useMutation(UPDATE_PHONE_NUMBER_BY_USER_ID, {
    onCompleted: () => {
      setIsOpen(false);
      setFailedIsOpen(false);
      setConfirmationIsOpen(true);
      setPhoneNumber("");
    },
    onError: () => {
      setIsOpen(false);
      setFailedIsOpen(true);
    }
  });

  const handleChangePhoneNumber = () => {
    if (loading) return;

    updatePhoneNumberByUserId({
      variables: {
        input: {
          userId,
          input: {
            phoneNumber
          }
        },
      },
    })
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Change Phone Number"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Enter New Email Address</Head>
        <Container>
          <Input
            title="EMAIL ADDRESS"
            required
            error={phoneNumberError}
            errorMessage="Please enter a valid email address"
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
              setPhoneNumberError(false);
            }}
            additionalstyle={`
            width: 100%;
          `}
          />
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onClick={handleChangePhoneNumber}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>
      <ModalChangeConfirmation
        isOpen={confirmationIsOpen}
        setIsOpen={setConfirmationIsOpen}
        phoneNumber={phoneNumber}
        retryFunction={handleChangePhoneNumber}
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        loading={loading}
        retryFunction={handleChangePhoneNumber}
        type="changeEmail"
      />
    </>
  );
};

export default ModalChangePhoneNumber;
